import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'smt-boolean',
  templateUrl: './boolean.component.html',
  styleUrls: ['./boolean.component.scss'],
})
export class BooleanComponent {
  @Input() group: FormGroup<any>;
  @Input() controlName: string;
  @Input() label: string;
  @Input() yesLabel: string;
  @Input() noLabel: string;
  @Input() interacted: boolean;
  @Input() showInList: boolean;

  constructor() {
    this.yesLabel = this.yesLabel || 'ALDEN.CUSTOM_LISTS.FILTERS.BOOLEAN_TRUE_TEXT';
    this.noLabel = this.noLabel || 'ALDEN.CUSTOM_LISTS.FILTERS.BOOLEAN_FALSE_TEXT';
  }

  get control(): AbstractControl<any, any> {
    return this.group.get(this.controlName);
  }

  get disabled(): boolean {
    return this.control.disabled;
  }

  get isRequired(): boolean {
    return this.control.hasValidator(Validators.required);
  }

  get isErrorVisile(): boolean {
    const control = this.group.get(this.controlName);
    return control.hasError('required') && (control.touched || control.dirty || this.interacted);
  }
}